import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

interface MakeFamilyFolderCommonApiCallParams {
    home: string;
}

export class MakeFamilyFolderCommonApiCall extends APICallV4<MakeFamilyFolderCommonApiCallParams | null> {
    _method = 'family/folder/unshare';
    _type: Method = 'post';
    _retriesCount = 0;
}
